module.exports = __webpack_public_path__ + "img/shoes.ce646bbc.png";